export default{
    "store.index.598093-0": "默认颜色",
    "store.index.598093-1": "炫酷蓝色",
    "store.index.598093-2": "数据模式",
    "store.index.598093-3": "地图模式",
    "store.index.598093-4": "智慧农业"
}


// WEBPACK FOOTER //
// ./src/i18n/lang/Zh/store-zh.js


// WEBPACK FOOTER //
// ./src/i18n/lang/Zh/store-zh.js